import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./track-page.module.css";
import "../App.css";
import moment from "moment";
import { Collapse } from "reactstrap";
function WaybillInfo({ data,isOpen }) {
  return (
    <Collapse isOpen={isOpen}>
      <p className={styles.main_info}>Waybill Information</p>
      <Container className={styles.main_info_container}>
        <Row>
          <Col md={6}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Waybill Number: </p>
              </Col>
              <Col>
                <p className="fw-normal">
                  {data.waybillnumber} ({data.currentStatus})
                </p>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Waybill Date: </p>
              </Col>
              <Col>
                <p className="fw-normal">
                  {moment(data.waybill_info?.shipping_date).format(
                    "DD/MM/YYYY"
                  )}
                </p>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Place of Delivery: </p>
              </Col>
              <Col className="fw-normal">
                <p>{data.destination?.name}</p>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Delivery Company: </p>
              </Col>
              <Col>
                <p className="fw-normal">
                  {data.waybill_info?.delivery_company}
                </p>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Place Of Receipt: </p>
              </Col>
              <Col className="fw-normal">
                <p>{data.createdBranch?.name}</p>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Delivery No: </p>
              </Col>
              <Col className="fw-normal">
                <p>{data.waybill_info?.delivery_no}</p>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Sale Person: </p>
              </Col>
              <Col className="fw-normal">
                <p>{data.waybill_info?.sale_person?.name}</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Collapse>
  );
}

export default WaybillInfo;
